import AiSummarySkeleton from "./AiSummarySkeleton";
import "./AiSummarySlot.scss";

const AiSummarySlot = ({ state, children }) => {
  if (state === "none") {
    return null;
  }

  const showSkeleton = state === "idle" || state === "loading";

  return (
    <>
      {showSkeleton && <AiSummarySkeleton />}
      <div style={{ display: showSkeleton ? "none" : "block" }}>
        {children}
			</div>
			<p className="search-title"><strong>Search Results</strong></p>
    </>
  );
};

export default AiSummarySlot;